import React from 'react';
import removeOtherTraffic from 'src/components/BeaconV2Components/utils/removeOtherTraffic';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import { useAppSelector } from 'src/utils/Hooks';
import { useCreateRemoveRetailPriceRangeFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy/useBaseMetricRequestBuilder';
import useKeywordSearchRequestBuilder from 'src/components/BeaconV2Components/ExperimentalLayout/Segments/KeywordsSearch/useKeywordSearchRequestBuilder';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';

/**
 * Bar chart for topics builder search results
 */
export default function TopicBuilderColumnChart({
  builderFunction
}: {
  builderFunction?: (
    additionalBuilder?: (builder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder
  ) => (requestBuilder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder;
}) {
  const keywordSearchRequestBuilder = useKeywordSearchRequestBuilder('traffic');
  const builderToUse = builderFunction || keywordSearchRequestBuilder;

  const removeRetailPriceRangeFilters = useCreateRemoveRetailPriceRangeFilters();
  const mainEntityType = useAppSelector((state) => state?.entityService?.mainEntity?.type);

  return (
    <BeaconDropdownMetricColumnChart
      fieldName="organicClicks"
      indexName="traffic"
      dropdownOptions={[
        {
          id: 'brandId',
          label: 'Brand'
        },
        {
          id: 'categoryId',
          label: 'Category'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory'
        }
      ].filter((option) => !option.id.toLowerCase().startsWith(mainEntityType))}
      useAdvancedSearchDataArgs={{
        requestBuilder: (builder) =>
          builder.apply(removeOtherTraffic).apply(removeRetailPriceRangeFilters()).apply(builderToUse())
      }}
      titlePrefix="Organic Traffic by"
    />
  );
}
